import { useState } from "react";

export default function usePaginatedList<T>(items: T[] | undefined, resetKey: string, pageSize = 10) {
  const [currentPage, setCurrentPage] = useState(1);
  const [prevResetKey, setPrevResetKey] = useState(resetKey);

  if (prevResetKey !== resetKey) {
    setPrevResetKey(resetKey);
    setCurrentPage(1);
  }

  const pageItems = items?.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return {
    pageItems,
    paginationProps: {
      current: currentPage,
      total: items?.length ?? 0,
      pageSize,
      onChange: (page: number) => setCurrentPage(page),
    },
  };
}
